import "@Styles/Controls/WakeLock/wakeLock_sm.less";
import wakeLockButton from './Buttons/_wakeLockButton';
export default {
  components: {
    'wakeLockButton': wakeLockButton
  },
  data: function data() {
    return {
      config: {},
      supported: false,
      wakeLockButton: ''
    };
  },
  methods: {
    init: function init(config) {
      if ('wakeLock' in navigator && 'request' in navigator.wakeLock) {
        this.wakeLockButton = 'wakeLockButton';
        this.config = config || {};
        this.supported = true;
      } else {
        if (window.GeneralMills.debugMode) console.log("Browser not supported");
      }
    }
  }
};